import React from "react";
import {post} from "./common/utils/http";
import AisinoButton from "./baseComponent/button/AisinoButton";
import ArrowLeftOutlined from "@ant-design/icons/es/icons/ArrowLeftOutlined";
import AisinoRow from "./baseComponent/rowAndCol/AisinoRow";
import axios from "./common/utils/axios";

class Guideline extends React.Component{
    state={
        invoicePdfUrl:''
    }
    componentDidMount() {
        post("aisino/attach/getGuidelinePDF",{},true)
            .then(response =>{
                // console.log(response);
                if(response != null){
                    this.setState({invoicePdfUrl:axios.defaults.baseURL + "/invoice/aisino/attach/previewGuideline?id="+response.id});
                }
            })
    }
    onCloseClick(){
        this.props.history.goBack();
    }
    render() {
        return (
            <div>
                <AisinoRow gutter={200} style={{marginLeft: '0px',marginRight: '0px',height: '95%'}}>
                    <AisinoButton onClick={() => this.onCloseClick()} icon={<ArrowLeftOutlined />}/>
                    <iframe
                        frameborder="0"
                        allowfullscreen="true"
                        webkitallowfullscreen="true"
                        mozallowfullscreen="true"
                        oallowfullscreen="true"
                        msallowfullscreen="true"
                        scrolling="yes"
                        style={{width: "100%", height: "100%",overflowX:"auto",overflowY:"auto"}}
                        src={this.state.invoicePdfUrl}>
                    </iframe>
                </AisinoRow>
            </div>

        );
    }
}
export default Guideline;
